export default class MobileCategoryMenu {
    constructor($el) {
        this.$el = $el;
        this.rootPanel = this.$el.querySelector('[data-mobile-category-panel]');
        this.activePanel = this.rootPanel;

        this.$el.querySelectorAll('[data-mobile-category-next]').forEach(($trigger) => {
            $trigger.addEventListener('click', () => this.showPanel($trigger.dataset.mobileCategoryNext, 'forward'));
        });

        this.$el.querySelectorAll('[data-mobile-category-back]').forEach(($trigger) => {
            $trigger.addEventListener('click', () => this.showPanel($trigger.dataset.mobileCategoryBack, 'back'));
        });

        window.addEventListener('remove-category-list', () => this.reset());
    }

    showPanel(panelId, direction) {
        const nextPanel = this.$el.querySelector(`[data-mobile-category-panel="${panelId}"]`);

        if (!nextPanel || nextPanel === this.activePanel) {
            return;
        }

        this.activePanel.hidden = true;
        this.activePanel.classList.remove('mobile-product-categories__panel--active');
        nextPanel.hidden = false;
        nextPanel.classList.remove(
            'mobile-product-categories__panel--forward',
            'mobile-product-categories__panel--back'
        );
        nextPanel.classList.add(
            'mobile-product-categories__panel--active',
            `mobile-product-categories__panel--${direction}`
        );
        this.activePanel = nextPanel;
        this.$el.closest('.modal-menu--mobile').scrollTop = 0;
    }

    reset() {
        if (!this.rootPanel) {
            return;
        }

        this.$el.querySelectorAll('[data-mobile-category-panel]').forEach(($panel) => {
            $panel.hidden = $panel !== this.rootPanel;
            $panel.classList.remove(
                'mobile-product-categories__panel--active',
                'mobile-product-categories__panel--forward',
                'mobile-product-categories__panel--back'
            );
        });

        this.rootPanel.classList.add('mobile-product-categories__panel--active');
        this.activePanel = this.rootPanel;
    }
}
